/**
 * Better Auth client for Sherlog web UI
 */
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
});

// Export hooks for convenience
export const { useSession, signIn, signOut } = authClient;

// Sign in with Google
export async function signInWithGoogle() {
  await signIn.social({
    provider: "google",
    // Preserve CLI device codes and other deep links through OAuth.
    callbackURL: window.location.href,
  });
}

// Sign out
export async function handleSignOut() {
  await signOut();
  // Reload the page to clear any cached state
  window.location.reload();
}
